import { Ref } from "vue";
/**
 * Sets the height of a component referenced by `targetRef`.
 * If `height` is not provided, sets the height to the window's inner height.
 *
 * *IMPORTANT*:
 * _Ensure the component is mounted before calling this function and
 * do not use the Bootstrap class 'h-100'._
 * @param targetRef - Vue ref to the target HTMLElement.
 * @param height - Optional height value (e.g., '100px', '50vh').
 */
export const resizeComponentHelper = (
  targetRef: Ref<HTMLElement | null>,
  height?: string
): void => {
  if (!targetRef.value) return;

  try {
    if (!height) {
      targetRef.value.style.height = window.innerHeight + "px";
      return;
    }

    targetRef.value.style.height = height;
  } catch (error) {
    console.error(error);
  }
};

/*Calculates a specified percentage of the window's inner height.
 *  @param percentage - The percentage of the window height to calculate (e.g., 65 for 65%).
 *  @returns The calculated height in pixels.
 */
export const getWindowHeightPercentage = (percentage: number): number => {
  if (percentage < 0 || percentage > 100) {
    return 0;
  }
  return (window.innerHeight * percentage) / 100;
};
